import Vue from 'vue'
import VueI18n from 'vue-i18n'

// messages
import es from './messages/es'
import fr from './messages/fr'
import it from './messages/it'
import en from './messages/en'
import de from './messages/de'

const numberFormats = {
  'es-ES': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  }
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'fr',
  fallbackLocale: 'fr',
  silentTranslationWarn: true,
  messages: {
    es,
    fr,
    it,
    en,
    de
  },
  numberFormats
})

export default i18n
